import BaseService from '@/services/BaseService';

class MenuService extends BaseService {
    getMenuList = (data) => this.post('/get-menu-list', data || {});

    viewMenu = (id) => this.get(`/view-menu/${id}`);

    updateSimpleMenu = (data, id) => this.post(`/edit-simple-menu/${id}`, data);

    getParentMenuList = (id) => this.get(`/get-parent-menu-list/${id}`);

    getSortMenuList = (id) => this.get(`/sort-menu-view/${id}`);

    getAdvancedMenuList = (id) => this.get(`/get-advanced-menu-list/${id}`);

    updateMenuLabel = (data, id) => this.post(`/edit-menu-label/${id}`, data);

    viewAdvancedMenu = (id) => this.get(`/view-advanced-menu/${id}`);

    updateAdvancedMenu = (data, id) => this.post(`/edit-advanced-menu/${id}`, data);
}

export default new MenuService();
